import { render, staticRenderFns } from "./FeaturedNewsItem.vue?vue&type=template&id=5b125fe2&scoped=true&"
import script from "./FeaturedNewsItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedNewsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b125fe2",
  null
  
)

export default component.exports